import React from 'react';
import List from './List';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { KPISetUnqualified, Dashboard } from '../components';

const dataProviderName = 'opportunities/proposal';

const Default = () => {
    const { item: user } = useDataProvider('auth/token');

    const now = new Date();
    const startOfYear = new Date(`${now.getFullYear()}-01-01`);
    const defaultFilters = {
        items: [
            {
                field: "registered_at",
                value: { from: startOfYear.toISOString().split('T')[0], to: now.toISOString().split('T')[0] },
                id:Math.floor(Math.random() * 5000) + 12500,
                operator: "between"
            }
        ]
    };    
    
    return (
        <>
            {!user?.data?.roles?.includes('Superadmin') &&
                <KPISetUnqualified dataProviderName={dataProviderName} />
            }
            {user?.data?.roles?.includes('Superadmin') &&
                <Dashboard dataProviderName={dataProviderName} filters={defaultFilters} />
            }

            <List filters={defaultFilters}/>
        </>
    )
}

export default Default;


